module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentImageSrc) ? _c('img', {
    attrs: {
      "src": _vm.currentImageSrc,
      "alt": "aperçu"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }) : _c('img', {
    attrs: {
      "src": "http://lorempixel.com/640/480/",
      "alt": "aperçu"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    attrs: {
      "size": "large"
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Librairie d'images")]), _vm._v(" "), _c('imageLibrary', {
    attrs: {
      "slot": "body"
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "imageChosen": _vm.updateImageSrc
    },
    slot: "body"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-2 columns"
  }, [_c('button', {
    staticClass: "light-grey-button full-width",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Annuler")])]), _vm._v(" "), _c('div', {
    staticClass: "large-5 columns large-offset-5"
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (_vm.showCropperModal) ? _c('modal', {
    attrs: {
      "size": "large"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Retouches d'images")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('imageCropper', {
    attrs: {
      "fileToCrop": _vm.fileChosen
    },
    on: {
      "imageChosen": _vm.updateImageSrc,
      "closeCropper": function($event) {
        _vm.showCropperModal = false
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9424abec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/image-editor.vue
// module id = 784
// module chunks = 0